// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__14g1N","col":"styles_col__2DJ8d"};